import React from 'react'
import { CircleAction } from '../utils/action/Action'
import { BLUE } from '../../utils/colors'
import { ControlButtonProps } from './types'

export const ButtonCamera = ({active, onPress}: ControlButtonProps) => <CircleAction  active={active} label={active ? 'Ligada' : 'Desligada'} color={BLUE} icon={active ? 'video' : 'video-off'} onPress={onPress} />
